import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Service } from '../domain/Service';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  services$ = new BehaviorSubject<Service[]>([]);

  constructor(private http: HttpClient) {
    this.getServices().subscribe((res) => {
    });
  }

  getServices(): Observable<any> {
    return this.http.get('/api/services').pipe(
      tap((res: any) => {               
        this.services$.next(res);
      })
    );
  }
}
